import { z } from 'zod/v3';
import { zIsoDate } from '../../common/utils';
import { ChangedBySchema } from '../../user';
import { DataVersionStatusSchema } from '../../input-data';

export const ProcessingEventDirectoryEntrySchema = z.object({
  id: z.number(),
  processingTypeId: z.number(),
  processingMethodId: z.number(),
  dataProcessingScopeId: z.number().nullable(),
  dataObjectId: z.number(),
  dataObjectGroupId: z.number(),
  dataObjectType: z.enum(['group', 'description']),
  dataObjectCodeName: z.string(),
  outputProcessingDataObjectId: z.number().nullable(),
  outputDataObjectDescriptionId: z.number().nullable(),
  outputDataObjectDescription: z.string().nullable(),
  outputDataObjectGroupType: z.string().nullable(),
  outputDataObjectDescriptionParent: z.string().nullable(),
  outputCalculationErrors: z.boolean(),
  outputVersionMissingSourceData: z.boolean(),
  outputVersionValidationErrorLevelId: z.number().int().nullable(),
  outputVersionStatus: DataVersionStatusSchema.nullable(),
  outputVersion: z.string().nullable(),
  outputVersionId: z.number().nullable(),
  valueDate: zIsoDate(),
  startTime: z.string().datetime({ offset: true }),
  endTime: z.string().datetime({ offset: true }),
  calculationStartTime: z.string().datetime({ offset: true }).nullable(),
  calculationEndTime: z.string().datetime({ offset: true }).nullable(),
  validationStartTime: z.string().datetime({ offset: true }).nullable(),
  validationEndTime: z.string().datetime({ offset: true }).nullable(),
  createdBy: ChangedBySchema,
  errorLevelId: z.number().nullable(),
  statusId: z.number().nullable(),
  hasAccess: z.boolean(),
  permissionToManage: z.boolean(),
});
